import { IUserFull } from '@gettactic/api';
import { UserAvatar } from '@v2/components/display/UserAvatar/UserAvatar';

export interface UserListItemProps {
  user: Partial<IUserFull>;
  rightElement?: JSX.Element | null;
}
export const UserListItem = ({
  user,
  rightElement = null
}: UserListItemProps): JSX.Element => (
  <li
    key={user.id}
    className="flex flex-nowrap items-center px-6 max-sm:px-0 max-sm:pr-2 py-4 max-w-full min-w-0"
  >
    <div className='flex flex-1 flex-nowrap items-center gap-4 min-w-0'>
      <div className="shrink-0">
        <UserAvatar
          user={{
            name: user.name,
            profile_photo_url: user.profile_photo_url
          }}
          size="lg"
        />
      </div>
      <div className="flex flex-col flex-nowrap text-sm min-w-0 flex-1">
        <h6 className='truncate font-bold text-tertiary'>{user.name || ''}</h6>
        {user.email ? (
          <p className="truncate font-normal text-tertiary">{user.email || ''}</p>
        ) : null}
        <p className="truncate font-normal text-tertiary">{user.title || ''}</p>
      </div>
    </div>
    <div className="flex flex-nowrap items-center gap-4 shrink-0">
    {rightElement}
    </div>
  </li>
);
